/**
 * Builds the DOM for the "complete sign-in" prompt shown after the browser is
 * redirected back from the auth domain. The token is pulled over via a popup,
 * and popups only open inside a user gesture — so the return flow can't finish
 * silently on page load; it needs this explicit button for the user to click.
 * Rendered by {@link OauthCompletePopup}.
 */
export const oauthCompletePopupView = () => {
    const container = document.createElement('div');
    container.className = 'popup-container oauth-session-popup oauth-complete-popup';
    const closeButton = document.createElement('div');
    closeButton.className = 'overlay-button overlay-button-close will-close';
    closeButton.setAttribute('role', 'button');
    closeButton.setAttribute('tabindex', '0');
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.appendChild(document.createElement('span'));
    const main = document.createElement('div');
    main.className = 'main';
    const title = document.createElement('h2');
    title.className = 'oauth-session-popup-title';
    title.textContent = 'Almost there';
    main.appendChild(title);
    const message = document.createElement('p');
    message.className = 'oauth-session-popup-email';
    message.textContent = 'Click below to finish signing in.';
    main.appendChild(message);
    const error = document.createElement('p');
    error.className = 'oauth-complete-popup-error';
    error.hidden = true;
    main.appendChild(error);
    const completeButton = document.createElement('button');
    completeButton.type = 'button';
    completeButton.className = 'oauth-session-popup-logout oauth-complete-popup-action';
    completeButton.textContent = 'Complete sign-in';
    main.appendChild(completeButton);
    container.appendChild(closeButton);
    container.appendChild(main);
    return container;
};
